module.exports = __webpack_public_path__ + "img/profile.5bc05ef2.png";